/**
 * Label + colour for the subscription badge in the admin users tab.
 *
 * Mirrors backend `subscription._has_active_trial`: a `trialing` profile whose
 * `trial_ends_at` is missing or not in the future has no access any more, so
 * it is shown as "trial expired" in red instead of the raw status.
 */
export type SubscriptionBadgeColor = "emerald" | "violet" | "red" | "slate";

export interface SubscriptionBadge {
  label: string;
  color: SubscriptionBadgeColor;
}

export function isTrialExpired(
  subscriptionStatus: string,
  trialEndsAt: string | null | undefined,
  now: Date = new Date(),
): boolean {
  if (subscriptionStatus !== "trialing") return false;
  if (!trialEndsAt) return true;
  const ends = new Date(trialEndsAt);
  if (Number.isNaN(ends.getTime())) return true;
  return ends.getTime() <= now.getTime();
}

export function subscriptionBadge(
  subscriptionStatus: string,
  trialEndsAt: string | null | undefined,
  now: Date = new Date(),
): SubscriptionBadge {
  if (isTrialExpired(subscriptionStatus, trialEndsAt, now)) {
    return { label: "trial expired", color: "red" };
  }
  if (subscriptionStatus === "active") return { label: subscriptionStatus, color: "emerald" };
  if (subscriptionStatus === "trialing") return { label: subscriptionStatus, color: "violet" };
  return { label: subscriptionStatus, color: "slate" };
}
